/* eslint-disable no-underscore-dangle,no-undef */
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import { reducer as formReducer } from 'redux-form';
import thunk from 'redux-thunk';
import { reducer as clientReducer } from './reducers/clients/clients.reducer';
import { reducer as currentUserReducer } from './reducers/currentUser/currentUser.reducer';
import { reducer as employeesReducer } from './reducers/employees/employees.reducer';
import { reducer as equipmentReducer } from './reducers/equipment/equipment.reducer';
import { reducer as equipmentCategoryReducer } from './reducers/equipmentCategory/equipmentCategory.reducer';
import { reducer as laborClassesReducer } from './reducers/laborClasses/laborClasses.reducer';
import { reducer as workOrdersReducer } from './reducers/workOrder/workOrders.reducer';
import resourceCreator from './reducers/middleware/resourceCreator/resourceCreator.middleware';
import resourceRemover from './reducers/middleware/resourceRemover/resourceRemover.middleware';
import resourceResolver from './reducers/middleware/resourceResolver/resourceResolver.middleware';
import resourceUpdater from './reducers/middleware/resourceUpdater/resourceUpdater.middleware';
import { reducer as projectsReducer } from './reducers/projects/projects.reducer';
import { reducer as employeeTimesheetsReducer } from './reducers/workOrder/employeeTimesheets/employeeTimesheets.reducer';
import { reducer as equipmentTimesheetsReducer } from './reducers/workOrder/equipmentTimesheets/equipmentTimesheets.reducer';
import { reducer as subcontractorTimesheetsReducer } from './reducers/workOrder/subcontractorTimesheets/subcontractorTimesheets.reducer';
import { reducer as materialsReducer } from './reducers/workOrder/material/material.reducer';
import { reducer as subContractorReducer } from './reducers/subContractor/subContractor.reducer';
import { reducer as costCodeReducer } from './reducers/costCode/costCode.reducer';
import { reducer as costCodeCategoryReducer } from './reducers/costCodeCategory/costCodeCategory.reducer';
import { reducer as paymentTypesReducer } from './reducers/paymentTypes/paymentTypes.reducer';
import { reducer as employeeStatsReducer } from './reducers/employeeStats/employeeStats.reducer';
import { reducer as subContractorStatsReducer } from './reducers/subContractorStats/subContractorStats.reducer';
import { reducer as rootReducer } from './reducers/root/root.reducer';

const store = createStore(
  rootReducer(
    combineReducers({
      currentUser: currentUserReducer,
      clients: clientReducer,
      employees: employeesReducer,
      equipments: equipmentReducer,
      projects: projectsReducer,
      laborClasses: laborClassesReducer,
      employeeTimesheets: employeeTimesheetsReducer,
      equipmentTimesheets: equipmentTimesheetsReducer,
      subcontractorTimesheets: subcontractorTimesheetsReducer,
      materials: materialsReducer,
      costCodes: costCodeReducer,
      workOrders: workOrdersReducer,
      subContractors: subContractorReducer,
      subContractorStats: subContractorStatsReducer,
      paymentTypes: paymentTypesReducer,
      employeeStats: employeeStatsReducer,
      costCodeCategories: costCodeCategoryReducer,
      equipmentCategories: equipmentCategoryReducer,
      form: formReducer,
    }),
  ),
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
  compose(applyMiddleware(thunk, resourceResolver, resourceRemover, resourceCreator, resourceUpdater)),
);

export default store;



// WEBPACK FOOTER //
// ./src/store.js